// extracted by mini-css-extract-plugin
export default {"post_detail":"PostDetail_post_detail__mmIf1","tags":"PostDetail_tags__aRH0M","createby":"PostDetail_createby__RodZT"};